import { Box } from "@mui/material";
import CheckIcon from "@/assets/icons/check.svg?react";
import RemoveIcon from "@mui/icons-material/Remove";

interface IProps {
  checked: boolean;
}

export const CheckedIcon: React.FC<IProps> = ({ checked }) => {
  return (
    <>
      {checked ? (
        <Box
          sx={{
            width: { xs: 18, md: 24 },
            height: { xs: 18, md: 24 },
            boxSizing: "border-box",
            ml: "auto",
            mr: { lg: "auto" },
            "& svg": {
              width: "100%",
              height: "100%",
            },
          }}
        >
          <CheckIcon />
        </Box>
      ) : (
        <RemoveIcon
          sx={{
            width: { xs: "10px !important", md: "12px !important" },
            height: { xs: "10px !important", md: "12px !important" },
          }}
          color="inherit"
        />
      )}
    </>
  );
};
